import React, { useState } from 'react'
import { ConnectAppModal } from './connectAppModal'
import './connectApp.scss'

export const ConnectAppLink: React.FC = () => {
    const [connecting, setConnecting] = useState(false)

    return (
        <>
            <p className="body1 connect-app-link-row">
                Not sure how to use these?&nbsp;
                <button type="button" className="bk-link connect-app-link" onClick={() => setConnecting(true)}>
                    Connect your app
                </button>
                .
            </p>
            {connecting && <ConnectAppModal onDismiss={() => setConnecting(false)} />}
        </>
    )
}
